/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/aoam-mobile-sheet.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/aoam-mobile-sheet.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
(function(){
  if (window.AOAM_SHEET) return; window.AOAM_SHEET = '2026-10-13.sheettop+2026-11-03.w1b';
  var mq = window.matchMedia('(max-width: 749px)');
  var ids = ['header-mobile__menu', 'header_minicart'];
  function closeBtn(d){ return d.querySelector('.js-drawer-close'); }
  function openDrawer(){ for (var i = 0; i < ids.length; i++) { var d = document.getElementById(ids[i]); if (d && d.classList.contains('js-drawer-open')) return d; } return null; }
  function close(d){ var b = d && closeBtn(d); if (b) b.click(); }
  function setup(){
    var first = document.getElementById(ids[0]) || document.getElementById(ids[1]);
    if (!first || document.querySelector('.aoam-sheet-dim')) return;
    var dim = document.createElement('div'); dim.className = 'aoam-sheet-dim'; dim.setAttribute('aria-hidden', 'true');
    first.parentNode.insertBefore(dim, first);
    var hs = document.createElement('style'); hs.id = 'aoam-sheet-handle-w1b';
    hs.textContent = '@media screen and (max-width:749px){html body button.aoam-sheet-handle{left:50%;right:auto;width:120px;height:44px;margin:0 0 0 -60px;padding:0;border:0;border-radius:0;background:none;box-shadow:none;-webkit-appearance:none;appearance:none;cursor:pointer;-webkit-tap-highlight-color:transparent;font:inherit;color:inherit;min-width:0;min-height:0}html body button.aoam-sheet-handle:focus{outline:none}html body button.aoam-sheet-handle:focus-visible::before{outline:2px solid #87F614;outline-offset:3px}}';
    document.head.appendChild(hs);
    dim.addEventListener('click', function(){ close(openDrawer()); });
    ids.forEach(function(id){
      var d = document.getElementById(id); if (!d) return;
      /* 2026-11-03 W1B (cart audit F-006, mockup E, Joel "lets ship all"): the grab handle is a real 120 x 44 button now,
         named "Close cart" / "Close menu", so a tap or a keyboard press closes the sheet as well as a drag. The look
         (the grey pill from aoam-il-aoam-mobile-sheet-1.css) does not change. Rollback: put back the aria-hidden div line. */
      var h = document.createElement('button'); h.type = 'button'; h.className = 'aoam-sheet-handle';
      h.setAttribute('aria-label', id === 'header_minicart' ? 'Close cart' : 'Close menu');
      h.addEventListener('click', function(){ if (mq.matches && d.classList.contains('js-drawer-open')) close(d); });
      d.appendChild(h);
      var y0 = null, dy = 0, fromHandle = false;
      function scroller(t){ while (t && t !== d) { if (t.scrollHeight > t.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(t).overflowY)) return t; t = t.parentElement; } return null; }
      d.addEventListener('touchstart', function(e){
        if (!mq.matches || !d.classList.contains('js-drawer-open') || e.touches.length !== 1) return;
        fromHandle = !!(e.target.closest && e.target.closest('.aoam-sheet-handle'));
        var sc = scroller(e.target);
        if (!fromHandle && sc && sc.scrollTop > 0) { y0 = null; return; }
        y0 = e.touches[0].clientY; dy = 0;
      }, { passive: true });
      d.addEventListener('touchmove', function(e){
        if (y0 === null) return;
        dy = e.touches[0].clientY - y0;
        if (dy <= 0) { if (!fromHandle) y0 = null; d.style.removeProperty('--aoam-sheet-drag'); d.classList.remove('aoam-sheet--drag'); return; }
        d.classList.add('aoam-sheet--drag'); d.style.setProperty('--aoam-sheet-drag', dy + 'px');
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      function end(){
        if (y0 === null) return; y0 = null;
        d.classList.remove('aoam-sheet--drag'); d.style.removeProperty('--aoam-sheet-drag');
        if (dy > Math.min(140, d.clientHeight * .22)) close(d);
        dy = 0;
      }
      d.addEventListener('touchend', end); d.addEventListener('touchcancel', end);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
/* 2026-10-12 (Claude) Joel "ship those" on the popup sheets mockup (OneDrive\Documents\AOAM-Mobile-Sheets-2026-10-12):
   drag down to close the size guide dialog and the lifetime warranty / duties popups on phones. Quick view
   already has its own drag in assets/aoam-addon-cards.js. Uses the CSS `translate` property so it never
   fights the !important transforms above. Delete this block to roll back the drag (the look stays). */
(function(){
  if (window.AOAM_SHEET_POP) return; window.AOAM_SHEET_POP = 1;
  var mq = window.matchMedia('(max-width: 749px)');
  var el = null, x0 = 0, y0 = 0, dy = 0, live = false;
  function sheetOf(t){
    if (!t || !t.closest) return null;
    var d = t.closest('dialog.aoam-guide-modal');
    if (d && d.open) return d;
    var p = t.closest('.protection_popup_containor');
    if (p && !p.classList.contains('hide')) return p;
    var nb = t.closest('.custom-non-us-restricted.active .non-us-restricted-content');
    if (nb) return nb;
    var ps = t.closest('.aoam-ps.on .aoam-ps-card');
    if (ps) return ps;
    return null;
  }
  function closeIt(s){
    if (s.tagName === 'DIALOG') { s.close(); return; }
    var x = s.querySelector('.pro_pop_close_icon, .close-btn-wrapper, .aoam-ps-skip'); if (x) x.click();
  }
  function reset(s, anim){ s.style.transition = anim ? 'translate .25s ease' : ''; s.style.translate = ''; }
  document.addEventListener('touchstart', function(e){
    el = null; live = false;
    if (!mq.matches || e.touches.length !== 1) return;
    var s = sheetOf(e.target); if (!s) return;
    var fromBar = !!e.target.closest('.aoam-guide-modal__bar');
    if (!fromBar && s.scrollTop > 0) return;
    el = s; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dy = 0;
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', function(e){
    if (!el) return;
    dy = e.touches[0].clientY - y0;
    if (!live && Math.abs(e.touches[0].clientX - x0) > Math.abs(dy)) { el = null; return; }
    if (dy <= 0) { if (live) { reset(el, false); live = false; } return; }
    if (!live && el.scrollTop > 0) { el = null; return; }
    live = true; el.style.transition = 'none'; el.style.translate = '0 ' + dy + 'px';
    if (e.cancelable) e.preventDefault();
  }, { passive: false, capture: true });
  function end(){
    if (!el) return; var s = el; el = null;
    if (!live) return; live = false;
    if (dy > Math.min(120, s.clientHeight * .22)) { reset(s, false); closeIt(s); } else reset(s, true);
    dy = 0;
  }
  /* Duties popup: tapping the dim above the sheet closes it (its wrap stops propagation, so capture). */
  document.addEventListener('click', function(e){
    if (!mq.matches || !e.target.classList || !e.target.classList.contains('custom-popup-close-overlay')) return;
    if (e.target.closest('.custom-duties-info-popup') && typeof window.close_custom_duty_popup === 'function') window.close_custom_duty_popup();
  }, true);
  /* 2026-10-12 Joel: "ship and test them" (sheet G). Tapping the dim above the signup step = Just browsing (its own click handler does the close). Delete this listener to roll back. */
  document.addEventListener('click', function(e){
    if (!mq.matches || !e.target.classList || !e.target.classList.contains('aoam-ps') || !e.target.classList.contains('on')) return;
    var k = e.target.querySelector('.aoam-ps-skip'); if (k) k.click();
  }, true);
  document.addEventListener('touchend', end, true); document.addEventListener('touchcancel', end, true);
})();
/* 2026-10-12 (Claude) Joel "ship it" on the currency sheet mockup: phone currency toggle ([data-disclosure-currency]) opens a
   bottom sheet built from the theme's own option list; picking a row clicks the original option, so the theme's
   localization form submit is unchanged. Delete this block to roll back. */
(function(){
  if (window.AOAM_CCY_SHEET) return; window.AOAM_CCY_SHEET = 1;
  var mq = window.matchMedia('(max-width: 749px)');
  var POP = ['USD', 'CAD', 'GBP', 'EUR', 'AUD'];
  var names = null, dim = null, sheet = null;
  try { names = new Intl.DisplayNames(['en'], { type: 'currency' }); } catch (e) {}
  function sym(c){ try { var p = new Intl.NumberFormat('en', { style: 'currency', currency: c, currencyDisplay: 'narrowSymbol' }).formatToParts(0); for (var i = 0; i < p.length; i++) if (p[i].type === 'currency') return p[i].value === c ? '' : p[i].value; } catch (e) {} return ''; }
  function nm(c){ try { return names ? names.of(c) : ''; } catch (e) { return ''; } }
  function code(o){ return o.getAttribute('data-value'); }
  function row(opt, cur){
    var c = code(opt), b = document.createElement('button');
    b.type = 'button'; b.className = 'aoam-ccy__row' + (c === cur ? ' is-current' : '');
    b.innerHTML = '<span class="aoam-ccy__code"></span><span class="aoam-ccy__name"></span><span class="aoam-ccy__sym"></span><span class="aoam-ccy__tick" aria-hidden="true"></span>';
    b.children[0].textContent = c; b.children[1].textContent = nm(c); b.children[2].textContent = sym(c);
    if (c === cur) b.setAttribute('aria-current', 'true');
    b.addEventListener('click', function(){
      close();
      if (c === cur) return;
      if (window.AOAM_LOAD && window.AOAM_LOAD.show) window.AOAM_LOAD.show();
      opt.click();
    });
    return b;
  }
  function drag(s){
    var body = s.querySelector('.aoam-ccy__body'), y0 = 0, x0 = 0, dy = 0, on = false, live = false;
    s.addEventListener('touchstart', function(e){
      on = false; live = false;
      if (e.touches.length !== 1) return;
      if (body.contains(e.target) && body.scrollTop > 0) return;
      on = true; y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0;
    }, { passive: true });
    s.addEventListener('touchmove', function(e){
      if (!on) return;
      dy = e.touches[0].clientY - y0;
      if (!live && Math.abs(e.touches[0].clientX - x0) > Math.abs(dy)) { on = false; return; }
      if (dy <= 0) { if (live) { s.style.transform = ''; live = false; } return; }
      live = true; s.style.transition = 'none'; s.style.transform = 'translate3d(0,' + dy + 'px,0)';
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    function end(){
      if (!on) return; on = false; s.style.transition = '';
      if (live && dy > Math.min(120, s.clientHeight * .22)) close(); else s.style.transform = '';
      live = false;
    }
    s.addEventListener('touchend', end); s.addEventListener('touchcancel', end);
  }
  function open(list){
    if (sheet) { sheet.remove(); dim.remove(); }
    var opts = [].slice.call(list.querySelectorAll('[data-disclosure-option]'));
    var curEl = list.querySelector('[aria-current="true"]'), cur = curEl ? code(curEl) : '';
    dim = document.createElement('div'); dim.className = 'aoam-ccy-dim'; dim.addEventListener('click', close);
    sheet = document.createElement('div'); sheet.className = 'aoam-ccy';
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Currency');
    sheet.innerHTML = '<div class="aoam-ccy__grab"></div><div class="aoam-ccy__head"><span class="aoam-ccy__eyebrow">Shop and pay in</span><span class="aoam-ccy__title">Currency</span></div><div class="aoam-ccy__body"></div>';
    var body = sheet.querySelector('.aoam-ccy__body');
    var pop = opts.filter(function(o){ return POP.indexOf(code(o)) > -1; }).sort(function(a, b){ return POP.indexOf(code(a)) - POP.indexOf(code(b)); });
    var rest = opts.filter(function(o){ return pop.indexOf(o) < 0; });
    function sec(t){ var d = document.createElement('div'); d.className = 'aoam-ccy__sec'; d.textContent = t; body.appendChild(d); }
    if (pop.length) { sec('Most shopped'); pop.forEach(function(o){ body.appendChild(row(o, cur)); }); sec('All currencies'); }
    rest.forEach(function(o){ body.appendChild(row(o, cur)); });
    document.body.appendChild(dim); document.body.appendChild(sheet);
    drag(sheet);
    document.documentElement.classList.add('aoam-ccy-open');
    void sheet.offsetHeight; dim.classList.add('is-open'); sheet.classList.add('is-open');
  }
  function close(){
    if (!sheet) return; var s = sheet, d = dim; sheet = dim = null;
    s.style.transform = ''; s.classList.remove('is-open'); d.classList.remove('is-open');
    document.documentElement.classList.remove('aoam-ccy-open');
    setTimeout(function(){ s.remove(); d.remove(); }, 320);
  }
  document.addEventListener('click', function(e){
    if (!mq.matches) return;
    var t = e.target.closest && e.target.closest('[data-disclosure-currency] [data-disclosure-toggle]');
    if (!t) return;
    var list = t.closest('[data-disclosure-currency]').querySelector('[data-disclosure-list]');
    if (!list) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open(list);
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sheet) close(); });
})();
/* 2026-10-12 (Claude) Joel "ship" on mockup E: on phones the country / region select (snippets/aoam-country-selector.liquid)
   opens a list sheet; picking sets the select and submits its own localization form. Delete this block to roll back. */
(function(){
  if (window.AOAM_CTRY_SHEET) return; window.AOAM_CTRY_SHEET = 1;
  var mq = window.matchMedia('(max-width: 749px)');
  var dim = null, sheet = null;
  function close(){
    if (!sheet) return; var s = sheet, d = dim; sheet = dim = null;
    s.style.transform = ''; s.classList.remove('is-open'); d.classList.remove('is-open');
    document.documentElement.classList.remove('aoam-ccy-open');
    setTimeout(function(){ s.remove(); d.remove(); }, 320);
  }
  function drag(s){
    var body = s.querySelector('.aoam-ccy__body'), y0 = 0, x0 = 0, dy = 0, on = false, live = false;
    s.addEventListener('touchstart', function(e){
      on = false; live = false;
      if (e.touches.length !== 1) return;
      if (body.contains(e.target) && body.scrollTop > 0) return;
      on = true; y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0;
    }, { passive: true });
    s.addEventListener('touchmove', function(e){
      if (!on) return;
      dy = e.touches[0].clientY - y0;
      if (!live && Math.abs(e.touches[0].clientX - x0) > Math.abs(dy)) { on = false; return; }
      if (dy <= 0) { if (live) { s.style.transform = ''; live = false; } return; }
      live = true; s.style.transition = 'none'; s.style.transform = 'translate3d(0,' + dy + 'px,0)';
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    function end(){
      if (!on) return; on = false; s.style.transition = '';
      if (live && dy > Math.min(120, s.clientHeight * .22)) close(); else s.style.transform = '';
      live = false;
    }
    s.addEventListener('touchend', end); s.addEventListener('touchcancel', end);
  }
  function open(sel){
    if (sheet) { sheet.remove(); dim.remove(); }
    var cur = sel.value;
    dim = document.createElement('div'); dim.className = 'aoam-ccy-dim'; dim.addEventListener('click', close);
    sheet = document.createElement('div'); sheet.className = 'aoam-ccy';
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Country or region');
    sheet.innerHTML = '<div class="aoam-ccy__grab"></div><div class="aoam-ccy__head"><span class="aoam-ccy__eyebrow">Ship to</span><span class="aoam-ccy__title">Country / region</span></div><div class="aoam-ccy__body"></div>';
    var body = sheet.querySelector('.aoam-ccy__body');
    [].forEach.call(sel.querySelectorAll('optgroup'), function(g){
      var h = document.createElement('div'); h.className = 'aoam-ccy__sec'; h.textContent = g.label; body.appendChild(h);
      [].forEach.call(g.querySelectorAll('option'), function(o){
        var m = /^(.*?)\s*\(([A-Z]{3})\)\s*$/.exec(o.textContent.trim()), name = m ? m[1] : o.textContent.trim(), ccy = m ? m[2] : '';
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'aoam-ccy__row aoam-ccy__row--wide' + (o.value === cur ? ' is-current' : '');
        b.innerHTML = '<span class="aoam-ccy__code"></span><span class="aoam-ccy__name"></span><span class="aoam-ccy__sym"></span><span class="aoam-ccy__tick" aria-hidden="true"></span>';
        b.children[1].textContent = name; b.children[2].textContent = ccy;
        if (o.value === cur) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function(){
          close();
          if (o.value === cur || !sel.form) return;
          sel.value = o.value;
          if (window.AOAM_LOAD && window.AOAM_LOAD.show) window.AOAM_LOAD.show();
          sel.form.submit();
        });
        body.appendChild(b);
      });
    });
    document.body.appendChild(dim); document.body.appendChild(sheet);
    drag(sheet);
    document.documentElement.classList.add('aoam-ccy-open');
    void sheet.offsetHeight; dim.classList.add('is-open'); sheet.classList.add('is-open');
    var c = body.querySelector('.is-current'); if (c && c.offsetTop > body.clientHeight) body.scrollTop = c.offsetTop - 120;
  }
  document.addEventListener('click', function(e){
    if (!mq.matches || !e.target.closest) return;
    var f = e.target.closest('.aoam-country__form'); if (!f) return;
    var sel = f.querySelector('select[data-aoam-country]'); if (!sel) return;
    e.preventDefault(); e.stopPropagation();
    open(sel);
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sheet) close(); });
})();
